import React from "react"
import {useRoomSetup, useLocal} from "../../AppContext"
import {InputSize} from "../Input"
import {SideBarRightBodyBlock, SideBarRightBodyBlockLabel, SideBarRightBodyBlockLabelHighlight, SideBarRightSectionLabel10} from "./SideBarRight"
import { ITEM_LAMP } from "../Canvas"

export const PropertiesSize = () => {
    const local = useLocal()

    return <>
        <SideBarRightSectionLabel10 label={local.__("Maße")}/>
        <Width/>
        <Depth/>
        <Height/>
        <Offset/>
    </>
}

const Width = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const value = roomSetup.itemGetProperty("width")

    const setValue = (event) => {
        roomSetup.itemSetWidth(event.target.value)
    }

    if (!roomSetup.itemAllowUserInput("width")) return null

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel>
            <SideBarRightBodyBlockLabelHighlight>{local.__("Breite")}</SideBarRightBodyBlockLabelHighlight>
            &nbsp;
            {local.__("in cm")}
        </SideBarRightBodyBlockLabel>
        <InputSize value={value} onChange={setValue}/>
    </SideBarRightBodyBlock>
}

const Depth = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const value = roomSetup.itemGetProperty("depth")

    const setValue = (event) => {
        roomSetup.itemSetDepth(event.target.value)
    }

    if (!roomSetup.itemAllowUserInput("depth")) return null

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel>
            <SideBarRightBodyBlockLabelHighlight>{local.__("Tiefe")}</SideBarRightBodyBlockLabelHighlight>
            &nbsp;
            {local.__("in cm")}
        </SideBarRightBodyBlockLabel>
        <InputSize value={value} onChange={setValue}/>
    </SideBarRightBodyBlock>
}

const Height = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const value = roomSetup.itemGetProperty("height")

    const setValue = (event) => {
        roomSetup.itemSetHeight(event.target.value)
    }

    if (!roomSetup.itemAllowUserInput("height")) return null

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel>
            <SideBarRightBodyBlockLabelHighlight>
                {isTypeLamp(roomSetup.itemGet()) ? local.__("Abhanghöhe") : local.__("Höhe")}
            </SideBarRightBodyBlockLabelHighlight>
            &nbsp;
            {local.__("in cm")}
        </SideBarRightBodyBlockLabel>
        <InputSize value={value} onChange={setValue}/>
    </SideBarRightBodyBlock>
}

const Offset = () => {
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const defaultYPosition = roomSetup.itemGetProperty("floorOffset")
    const value = roomSetup.itemGetProperty("position")?.y || defaultYPosition

    const setValue = (event) => {
        roomSetup.itemSetOffset(event.target.value)
    }

    if (!roomSetup.itemAllowUserInput("floorOffset")) return null

    return <SideBarRightBodyBlock>
        <SideBarRightBodyBlockLabel>
            <SideBarRightBodyBlockLabelHighlight>{local.__("Abstand vom Boden")}</SideBarRightBodyBlockLabelHighlight>
            &nbsp;
            {local.__("in cm")}
        </SideBarRightBodyBlockLabel>
        <InputSize value={value} onChange={setValue}/>
    </SideBarRightBodyBlock>
}

function isTypeLamp(item) {
    return item.type === ITEM_LAMP
}
